import { useEffect, useState } from 'react';
import { IFollowUpSurveyForList } from '@nkr/models/index';
import FileUpload from '@nkr/components/file-upload';
import { Button, Modal } from 'react-bootstrap';
import { DropEvent, FileRejection } from 'react-dropzone';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    data: IFollowUpSurveyForList,
    onUpload: (file: File) => void,
    onCancel: () => void
}

const UploadLabOrders = (props: IProps) => {
    const [files, setFiles] = useState<File[]>([]);
    const previousShow = usePrevious(props.show);

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleRemoveFile = (name: string) => {
        setFiles([]);
    };

    const handleUpload = () => {
        props.onUpload(files[0]);
    };

    useEffect(() => {
        if (previousShow == false && props.show) {
            setFiles([]);
        }
    }, [props.show]);

    const firstName = props.data != null ? props.data.firstName : '';
    const lastName = props.data != null ? props.data.lastName : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Upload Lab Orders File for <span style={{ color: 'darkgreen', fontWeight: 'bold' }}>{firstName} {lastName}</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FileUpload
                    label='Click here to select a PDF file to upload...'
                    files={files}
                    accept='.pdf'
                    onFileDropped={handleFileDropped}
                    onRemoveFile={handleRemoveFile}
                    singleUploadOnly={false}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' disabled={files.length == 0} onClick={handleUpload}>Upload &amp; Notify Donor</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UploadLabOrders;